<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">

      <section id="horizontal-form-layouts">


        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-md-4">
                    <h4 class="card-title" id="horz-layout-colored-controls">Device Manage </h4>

                  </div>
                  <div class="col-sm-3 col-6">
                    <select (change)="selectChangeHandler($event)" class="browser-default custom-select">
                      <option selected>Select Device</option>
                      <option *ngFor="let item of Device" value="{{item.device_id}}" >{{item.deviceName}}</option>

                    </select>


                  </div>
                  <div class="col-sm-3 col-6">
                    <button class="btn btn-info" (click)="LoadAllDevices()">
                      <i style="font-size: x-large;" class="fa fa-refresh"></i>
                    </button>
                  </div>
                  <br>

                </div>

              </div>
              <div class="card-content">
                <div class="px-3">
                  <form class="form form-horizontal">
                    <div class="form-body">
                      <h4 class="form-section"><i class="ft-cpu"></i> Device Controls</h4>
                      <div class="row">
                        <div class="col-md-4">
                          <input class="btn btn-primary" (click)="SetSync()" type="button" id="userinput1" name="firstname"
                            value="Set Sync">
                            <p class="text-muted">Device name must be english charactors!</p>
                        </div>
                        <div class="col-md-4">
                          <input class="btn btn-danger" (click)="ClearLogData()" type="button" id="userinput1" name="firstname"
                            value="Clear Log Data">
                            <p class="text-muted">Delete All data from machine and system!</p>

                        </div>
                        <div class="col-md-4">
                          <input class="btn btn-info" (click)="ResetMachine()" type="button" id="userinput1" name="firstname" value="Restart Machine">
                          <p class="text-muted">Restart Machine </p>
                        </div>


                      </div>


                      <h4 class="form-section"><i class="ft-settings"></i> Device Info</h4>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group row">
                            <label class="col-md-2 label-control" for="userinput5">Device Name </label>
                            <div class="col-md-3">
                              <input #DeviceName class="form-control border-primary"   name="DeviceName" type="text" id="userinput5">
                              <p class="text-muted">* Attention: Device name must be english charactors!</p>
                            </div>


                            <!-- <div class="col-md-3">
                              <select #DeviceType name="DeviceMode" class="browser-default custom-select">
                                <option selected>IN</option>
                                <option >OUT</option>
                              </select>


                            </div> -->
                            <div class="col-md-4">

                              <!-- <input class="btn btn-success"  (click)="UpdateDeviceName(DeviceName.value+'-'+DeviceType.value)" type="button" name="firstname"  value="Device Name"> -->
                              <input class="btn btn-success"  (click)="UpdateDeviceName(DeviceName.value)" type="button" name="firstname"  value="Device Name">
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>


                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>



      </section>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h4 style="color: white">Please Wait ... </h4>
  </ngx-spinner>
